<script>
import Pagination from '@/components/pagination'
import Loader from '@/components/widgets/loader'
import AlertError from '@/components/alert_error'
import {swal, imageError} from '../../../helpers/handle_error';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { Pagination, Loader, AlertError },
  data() {
    return {
      //Page errors.
      errors: [],

      //Pagination info.
      showLoader: true,
      page: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 8,
      orderPage: 'desc',
      enterPageNo: null,

      videoOpened: '',
    };
  },
  computed:{
    ...mapGetters('video', ['getVideos'])
  },
  methods:{
    ...mapActions('video', ['getAll', 'delete']),
    imageError,
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    async deleteItem(id) {
      if(await swal.confirm()){
        this.delete(id)
        .then((response)=>{
          swal.success(response.data.message)
        })
        .catch(this.handleError)
      }
    },
    fetchAll(){
      this.getAll({
        per_page: this.recordsPerPage,
        page: this.page,
        order: this.orderPage
      })
      .then((response)=>{
        this.page = response.data.meta.current_page
        this.totalPages = response.data.meta.last_page
        this.totalRecords = response.data.meta.total
        this.showLoader = false
      })
      .catch((error)=>{
        this.handleError(error)
        this.showLoader =false
      })
    },
    onPageChange (page) {
      this.page = page
      this.fetchAll()
    },
    onChangeRecordsPerPage () {
      this.fetchAll()
    },
    gotoPage () {
      if (!isNaN(parseInt(this.enterPageNo))) {
        if(this.enterPageNo > 0 && this.enterPageNo <= this.totalPages){
          this.page = parseInt(this.enterPageNo)
          this.fetchAll()
        }else{
          swal.error(`الصفحات المتوفرة من ( ${1} ) الى ( ${this.totalPages} )`, 'warning')
        }
      }
    },
    openVideo(uuid){
      this.videoOpened = 'https://www.youtube.com/embed/' + uuid
    }
  },
  created () {
    this.fetchAll()
  }
};

</script>

<template>
  <div>

    <AlertError :errors="errors"></AlertError>


    <Loader :loading="showLoader" >

      <div class="row mb-3 mt-3">
        <div class="col-md-3">
          <label class="form-label">عرض الفيديوات : </label>
          <select class="form-control form-control-sm" @change="onChangeRecordsPerPage" v-model="recordsPerPage">
            <option :value="8">8</option>
            <option :value="16">16</option>
            <option :value="24">24</option>
            <option :value="32">32</option>
            <option :value="40">40</option>
          </select>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <b-form @submit.prevent="gotoPage">
            <label class="form-label">انتقل للصفحة : </label>
            <div class="input-group">
              <input type="text" class="form-control form-control-sm" v-model="enterPageNo" />
              <button class="btn btn-secondary btn-sm" type="submit"> انتقل </button>
            </div>
          </b-form>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3" v-for="video in  (getVideos.slice(0, recordsPerPage))" :key="video.id">
          <div class="card p-1 border shadow-none">
            <div class="position-relative">
              <div class="play-video">
                <span v-b-modal.modal-video @click="openVideo(video.video_uuid)"><i class="bx bx-play"></i></span>
              </div>
              <img :src="video.video_image" @error="imageError" alt="" class="cover-img"/>
            </div>
            <div class="p-3 text-center">
              <p class="text-muted mb-0"> <i class="bx bx-calendar-alt align-middle text-muted me-1"></i> {{ video.created_at }}</p>
              <p class="short-text-2">{{ video.published ? 'منشور':'غير منشور' }} </p>
              <div class="text-center text-muted content-divider mb-1">
                <span class="px-2 short-text-1">{{ video.Title }}</span>
              </div>
              <div class="button-items">
                <router-link :to="{ name: 'videos.edit', params: { id: video.id } }">
                  <b-button v-can="'edit_video'" type="button" class="btn btn-sm btn-warning w-xs">تعديل</b-button>
                </router-link>
                <b-button v-can="'delete_video'" type="button" class="btn btn-sm btn-danger w-xs" @click="deleteItem(video.id)">حذف</b-button>
              </div>
            </div>
          </div>
        </div>

        <b-modal id="modal-video" centered title="عرض الفيديو" title-class="font-18" hide-footer>
          <i class="bx bx-loader-circle bx-spin loaded-video"></i>
          <div class="ratio ratio-16x9">
            <iframe class="embed-responsive-item con-iframe" :src="videoOpened"></iframe>
          </div>
        </b-modal>

        <h3 v-if="getVideos.length === 0" class="text-center mt-4">لا توجد بيانات لعرضها !</h3>
      </div>

      <Pagination v-if="getVideos" :total-pages="totalPages" :per-page="recordsPerPage" :current-page="page" @pagechanged="onPageChange" />
    </Loader>
  </div>       
</template>